<template>
  <div class="local-modal__wrapper" :class="{'local-modal__wrapper--visible': visible && !this.hiding}">
    <div v-if="visible" class="local-modal__background" @click="close"></div>
    <local-modal-mask v-if="visible && maskComponent"/>
    <local-modal v-if="visible"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { path } from 'ramda'
import LocalModal from './LocalModal'
import LocalModalMask from './LocalModalMask'

const getStateValue = (prop) => path(['localModal', prop])

export default {
  name: 'LocalModalWrapper',
  components: { LocalModalMask, LocalModal },
  data() {
    return {
      visible: false,
      hiding: false,
    }
  },
  computed: {
    ...mapState(
      {
        targetElement: getStateValue('targetElement'),
        maskComponent: getStateValue('maskComponent'),
      },
    ),
  },
  watch: {
    targetElement() {
      if (this.targetElement === null) {
        this.hiding = true
        setTimeout(() => {
          this.visible = false
          this.hiding = false
        }, 600)
      } else {
        this.visible = true
      }
    },
  },
  methods: {
    ...mapActions(
      {
        close: 'localModal/close',
      },
    ),
  },
}
</script>
